var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.5 21.5",
    style: {
      enableBackground: "new 0 0 21.5 21.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,21.5c-2,0-3.5-1.5-6.4-4.4C1.5,14.2,0,12.8,0,10.8s1.5-3.5,4.4-6.4C7.3,1.5,8.7,0,10.8,0 s3.5,1.5,6.4,4.4c2.9,2.9,4.4,4.4,4.4,6.4s-1.5,3.5-4.4,6.4C14.2,20,12.8,21.5,10.8,21.5z M10.8,1.5C9.3,1.5,8,2.8,5.4,5.4 s-3.9,3.9-3.9,5.3s1.3,2.7,3.9,5.3c5.2,5.2,5.4,5.2,10.7,0c2.6-2.6,3.9-3.9,3.9-5.3S18.7,8,16.1,5.4S12.2,1.5,10.8,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,13.5c-0.4,0-0.8-0.3-0.8-0.8c0-2.4,2-3.2,3.4-3.2h3.4l-1.3-1.2c-0.3-0.3-0.3-0.8,0-1.1 c0.3-0.3,0.8-0.3,1.1,0l2.7,2.5c0,0,0,0,0,0c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0l0,0l0,0c0,0.1,0.1,0.2,0.1,0.3l0,0l0,0l0,0v0 l0,0v0l0,0l0,0l0,0c0,0.1,0,0.2-0.1,0.3c0,0.1,0,0.1,0,0l0,0c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0l-2.7,2.5 c-0.3,0.3-0.8,0.3-1.1,0s-0.3-0.8,0-1.1l1.3-1.2H9.4c-0.1,0-1.9,0-1.9,1.8C7.5,13.2,7.2,13.5,6.8,13.5L6.8,13.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartRoute);
export default __webpack_public_path__ + "static/media/startRoute.f842274f64ca3b500bc7333376f13603.svg";
export { ForwardRef as ReactComponent };